module.exports = __webpack_public_path__ + "static/media/vip_custom_qrcode.8d62e6e6.jpg";